import React from "react";
import { useAuth } from "../hooks/useAuth";

export const NotApprovedPage: React.FC = () => {
  const { user } = useAuth();

  return (
    <div style={{ padding: "1rem" }}>
      <h1>Freischaltung ausstehend</h1>
      <p>
        Hallo {user?.email}, dein Account ist registriert, aber noch nicht
        von einem Administrator freigeschaltet.
      </p>
      <p>
        Status: <strong>{user?.status}</strong>
      </p>
      <p>Bitte gedulde dich oder kontaktiere deinen Ansprechpartner.</p>
    </div>
  );
};
